import { ColocaLogo } from "@/shared/components/ColocaLogo";
import useTranslations from "@/shared/lang/useTranslations";

export const FullScreenLoader = () => {
  const { t } = useTranslations("global");

  return (
    <div className="w-full min-h-screen bg-[#00735C] gap-5 dark:bg-zinc-800 flex flex-col justify-center items-center">
      <ColocaLogo variant="white" className="max-w-48" />
      <h4 className="text-white font-semibold animate-pulse">{t("loading_button")}</h4>
    </div>
  );
};
